module.exports = __webpack_public_path__ + "ENG_SPS10-Recess-b007b3701f6e8261076fd672cf3a720f.png";